import React from 'react'
import Head from 'next/head'

import { Container } from '@components/Container'
import { RecommendedArticle } from '@components/RecommendedArticle'
import { CategoryDetail } from '@components/CategoryDetail'
import { BookEnum } from '@interfaces/BookEnum'
import { CategoryList } from './components/CategoryList'
import { CategoryPageProps } from './interface'

const CategoryPage = ({
  category,
  bookType,
  isEbook,
  categoryId,
  bookTypeName,
  tab,
  orderBy,
  secondaryType,
  advanceSearch,
}: CategoryPageProps) => {
  const title = `${bookTypeName} ${category?.name ? `- ${category.name}` : ''} `

  return (
    <Container className='tablet-mobile:pt-[20px] tablet-mobile:pb-[30px] desktop:py-[30px]'>
      {bookType === BookEnum.NOVEL ? (
        <Head>
          <title>{category.seoTitleNovel}</title>
        </Head>
      ) : (
        <Head>
          <title>{category.seoTitleManga}</title>
        </Head>
      )}

      <h1 className='font-mitr border-b-[1px] border-gray-3 dark:border-purple mb-[20px] pb-[20px] topic-base text-primary tablet-mobile:mx-[15px] tablet-mobile:mb-[10px] tablet-mobile:pb-[10px]'>
        {title}
      </h1>
      <RecommendedArticle
        direction='vertical'
        isShowNavigation
        categoryId={categoryId}
        bookType={bookType}
        isEbook={isEbook}
      />
      <CategoryList
        isEbook={isEbook}
        tab={tab}
        orderBy={orderBy}
        secondaryType={secondaryType}
        advanceSearch={advanceSearch}
      />
      <div className='mobile:px-[20px]'>
        <hr className='text-gray-3 dark:text-purple my-[50px]' />
        <CategoryDetail
          title={title}
          description={
            bookType === BookEnum.NOVEL
              ? category?.seoNovel
              : bookType === BookEnum.MANGA
              ? category?.seoManga
              : ''
          }
        />
      </div>
    </Container>
  )
}

export default CategoryPage
